export { default } from './Unsupported'



// WEBPACK FOOTER //
// ./src/components/Unsupported/index.js